import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Typography, Box, Button, Paper, Stack } from "@mui/material";
import {
  getStoredRoles,
  hasAllowedRole,
  isUserAuthenticated,
} from "../utils/authSession";
import { getDefaultAuthorizedPath } from "../utils/roleAccess";

const UnauthorizedPage = ({ allowedRoles = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const userRoles = getStoredRoles();
  const requiresRoleCheck = Array.isArray(allowedRoles) && allowedRoles.length > 0;
  const isAuthenticated = isUserAuthenticated();
  const hasAccess = hasAllowedRole(allowedRoles, userRoles);

  useEffect(() => {
    if (!requiresRoleCheck || hasAccess) {
      return;
    }

    const roleText = userRoles.length ? userRoles.join(", ") : "NO_ROLE";
    console.warn(
      `Unauthorized access attempt by roles: ${roleText} on path: ${location.pathname}`
    );
  }, [hasAccess, location.pathname, requiresRoleCheck, userRoles]);

  if (requiresRoleCheck && !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiresRoleCheck && hasAccess) {
    return <Outlet />;
  }

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "grid",
        placeItems: "center",
        p: { xs: 2, md: 4 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          width: "100%",
          p: { xs: 3, md: 4 },
          borderRadius: 1.5,
          border: "1px solid",
          borderColor: "divider",
          textAlign: "center",
        }}
      >
        <Typography variant="h4" color="error.main" gutterBottom>
          403 - Unauthorized
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You do not have permission to access this screen.
        </Typography>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Go Back
          </Button>
          <Button
            variant="contained"
            onClick={() =>
              navigate(
                isAuthenticated ? getDefaultAuthorizedPath(userRoles) : "/login",
                { replace: true }
              )
            }
          >
            {isAuthenticated ? "Go to Dashboard" : "Go to Login"}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default UnauthorizedPage;
